export default {
  pullText: '下拉刷新',
  dropText: '释放立即刷新',
  loadingText: '加载中',
  successText: '加载成功',
  failureText: '加载失败',
  completeText: '我是有底线的'
};